import { render, staticRenderFns } from "./deliverGoods.vue?vue&type=template&id=32206f39&scoped=true"
import script from "./deliverGoods.vue?vue&type=script&lang=js"
export * from "./deliverGoods.vue?vue&type=script&lang=js"
import style0 from "./deliverGoods.vue?vue&type=style&index=0&id=32206f39&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32206f39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32206f39')) {
      api.createRecord('32206f39', component.options)
    } else {
      api.reload('32206f39', component.options)
    }
    module.hot.accept("./deliverGoods.vue?vue&type=template&id=32206f39&scoped=true", function () {
      api.rerender('32206f39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/siteinfo/deliverGoods/deliverGoods.vue"
export default component.exports